export default __webpack_public_path__ + "guide--raster-rasters-emspectrum-960-f6b2c7676eda615c0a12779ae4211117.webp";